import { useEffect } from "react";
import { withRouter } from "react-router-dom";

type Props = {
  location: {
    pathname?: string;
  };
  history: {
    push?: $TSFixMeFunction;
  };
};

export function AutoRouting({ location, history }: Props) {
  useEffect(() => {
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const brackets = location.pathname.split("/");
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    history.push(brackets.splice(0, brackets.length - 1).join("/"));
  }, [location]);

  return <div>...</div>;
}

export default withRouter(AutoRouting);
